import storage from './storage.js'
import router from "@/router/index.js"
import elementUI from 'element-ui'

let lastTime = new Date().getTime()
let currentTime = new Date().getTime()
let timeOut = 1000 * 60 * 100 //设置超时时间: 10分钟

window.onload = function () {
    // console.log("页面重新加载");
    storage.setItem("lastTime", new Date().getTime())
    
    window.document.onmousedown = function () {
        // console.log("页面点击");
        storage.setItem("lastTime", new Date().getTime())
    }
};


// 定时检测会话是否过期
function checkTimeout() {
    currentTime = new Date().getTime() //更新当前时间
    if (storage.getItem('user_token') && storage.getItem('login')) {
        lastTime = storage.getItem("lastTime");

        if (currentTime - lastTime > timeOut) { //判断是否超时
            // 清除storage的数据(登陆信息和token)
            // storage.clear()

            localStorage.removeItem('user_token');
            localStorage.removeItem('user_data');
            localStorage.removeItem('login');
            localStorage.removeItem('lastTime');

            // 跳到登陆页
            if (router.history.current.name == 'login') {
                return // 当前已经是登陆页时不做跳转
            }
            // 弹出提示框 
            elementUI.MessageBox.alert('您长时间未使用平台，请重新登录', '提示', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                callback: action => {
                    router.push('login');
                    location.reload();
                }
            });

        }

    }
}

export default function () {
    /* 定时器 间隔30秒检测是否长时间未操作页面 */
    window.setInterval(checkTimeout, 30000);
}



// WEBPACK FOOTER //
// ./src/utils/astrict.js